<template>
  <div class="page-wrapper">
    <card class="card-centered">
      <p><img src="/img/cyto-logo.png"></p>
      <h5>Welcome to <b>CytoScriba</b></h5>
      <p class="small">Please sign in with your cytoreason.com account:</p>
      <p id="firebaseui-auth-container"></p>
    </card>
  </div>
</template>
<script>
import '../services/FirebaseService';
import 'firebaseui/dist/firebaseui.css';
import { GoogleAuthProvider } from 'firebase/auth';
import { notificationService } from '../services/NotificationsService';
import { firebase } from '../services/FirebaseService';
import { router } from '../routes/router';

export default {
  mounted() {
    debugger
    firebase.authUI.start('#firebaseui-auth-container', {

      signInFlow: 'popup',
      // signInSuccessUrl: location.origin,
      signInOptions: [
        GoogleAuthProvider.PROVIDER_ID,
      ],
      tosUrl: 'https://www.cytoreason.com/terms',
      privacyPolicyUrl: 'https://www.cytoreason.com/privacy',
      callbacks: {
        signInSuccessWithAuthResult: (authResult, redirectUrl) => {
          router.push('/scriba/');
          return false;
        },
        signInFailure: (error) => {
          notificationService.error(`Login failed, please refresh and try again`);
          return false;
        },
      },
    });
  },
};
</script>

<style>
.page-wrapper {
  display: flex;
  height: 100%;
  width: 100%;
  position: absolute;
  background: rgba(203, 203, 210, .15);
}

.card-centered {
  display: flex;
  padding: 30px 10px;
  align-items: center;
  text-align: center;
  margin: auto;
  width: 260px;
}

#firebaseui-auth-container {
  margin: auto;
  min-width: 200px;
}
</style>
